// extracted by mini-css-extract-plugin
module.exports = {"notRated":"styles_notRated__2c-LX","rated":"styles_rated__3txGK"};